import {
  Audio,
  Calendar,
  Chat,
  Document,
  Edit,
  Envelop,
  EnvelopGreen,
  Facebook,
  Heart,
  Home,
  Inquiry,
  Instagram,
  Linkedin,
  LogoutIcon,
  Messages,
  MessagesWhite,
  One,
  People,
  Phone,
  Photo,
  Poll,
  ProfileImg,
  Repost,
  Settings,
  User,
  UserIcon,
  Video,
  Whatsapp,
  World,
  WorldGreen,
  XSocial,
  Youtube,
} from "../components/styled/AllImages";
import { formatDate, getFormattedTime, reqFormatDate } from "../utils";

export const profileDropdownList = [
  // {
  // 	label: "Profile",
  // 	icon: UserIcon,
  // 	path: "profile"
  // },
  {
    label: "edit_profile",
    icon: Edit,
    path: "/profile",
  },
  {
    label: "settings",
    icon: Settings,
    path: "/change-password",
  },
  {
    label: "Logout",
    icon: LogoutIcon,
    path: "",
  },
];
export const SidebarList = [
  {
    title: "home",
    icon: Home,
    url: "home",
  },
  {
    title: "people",
    icon: People,
    url: "people",
  },
  {
    title: "messages",
    icon: Messages,
    url: "messages",
  },
  {
    title: "settings",
    icon: Settings,
    url: "change-password",
  },
];
export const UploadBtnsList = [
  {
    icon: Photo,
    title: "Photo",
  },
  {
    icon: Audio,
    title: "Audio",
  },
  {
    icon: Video,
    title: "Video",
  },
  {
    icon: Poll,
    title: "Poll",
  },
  {
    icon: Inquiry,
    title: "Inquiry",
  },
];
export const PostedInteractionList = [
  {
    icon: <Heart />,
    title: "Likes",
    count: "20",
  },
  {
    icon: <Chat />,
    title: "Comments",
    count: "12",
  },
  {
    icon: <Repost />,
    title: "Repost",
  },
];
export const ProfileSidebarList = [
  {
    title: "PersonalInformation",
    icon: User,
  },
  {
    title: "FALInformation",
    icon: Document,
  },
  {
    title: "ContactDetails",
    icon: Envelop,
  },
  {
    title: "WebSocialMedia",
    icon: World,
  },
];
export const ChangePasswordSidebarList = [
  {
    title: "ChangePassword",
    icon: User,
    switch: false,
    // url: "/profile"
  },
  {
    title: "setAvailability",
    icon: Calendar,
    switch: true,
    // url: "/profile"
  },
];
export const PeopleDetailsBoxesList = [
  {
    id: 1,
    profile: ProfileImg,
    name: "DevonLane",
    location: "Riyadh",
    falId: "FAL",
    status: "Follow",
    role: [
      {
        userRole: "RealEstateBrokerage",
      },
    ],
  },
  {
    id: 2,
    profile: ProfileImg,
    name: "RobertFox",
    location: "Jeddah",
    falId: "FAL",
    status: "Follow",
    role: [
      {
        userRole: "RealEstateBrokerage",
      },
      {
        userRole: "RealEstateMarketing",
      },
    ],
  },
  {
    id: 3,
    profile: ProfileImg,
    name: "DevonLane",
    location: "Riyadh",
    falId: "FAL",
    status: "Follow",
    role: [
      {
        userRole: "RealEstateBrokerage",
      },
    ],
  },
  {
    id: 4,
    profile: ProfileImg,
    name: "RobertFox",
    location: "Jeddah",
    falId: "FAL",
    status: "Follow",
    role: [
      {
        userRole: "RealEstateBrokerage",
      },
      {
        userRole: "RealEstateMarketing",
      },
    ],
  },
  {
    id: 5,
    profile: ProfileImg,
    name: "DevonLane",
    location: "Riyadh",
    falId: "FAL",
    status: "Follow",
    role: [
      {
        userRole: "RealEstateBrokerage",
      },
    ],
  },
  {
    id: 6,
    profile: ProfileImg,
    name: "RobertFox",
    location: "Jeddah",
    falId: "FAL",
    status: "Follow",
    role: [
      {
        userRole: "RealEstateBrokerage",
      },
      {
        userRole: "RealEstateMarketing",
      },
    ],
  },
];

export const PeopleContactBtnsList = [
  {
    icon: MessagesWhite,
    title: "Message",
    bg: "var(--themeColor)",
  },
  {
    icon: Whatsapp,
    bg: "var(--bg)",
  },
  {
    icon: EnvelopGreen,
    bg: "var(--bg)",
  },
  {
    icon: Phone,
    bg: "var(--bg)",
  },
  {
    icon: WorldGreen,
    bg: "var(--bg)",
  },
];
export const SocialProfile = [
  {
    icon: <Youtube />,
    url: "#!",
  },
  {
    icon: <Linkedin />,
    url: "#!",
  },
  {
    icon: <XSocial />,
    url: "#!",
  },
  {
    icon: <Instagram />,
    url: "#!",
  },
  {
    icon: <Facebook />,
    url: "#!",
  },
  {
    icon: <One />,
    url: "#!",
  },
];

export const ContactsListing = [
  {
    label: "office",
    info: "+966 963852741",
  },
  {
    label: "MobileNumber",
    info: "+966 963852741",
  },
  {
    label: "email",
    info: "m.abdullah@example.com",
  },
];
export const PropertyDropdownList = [
  {
    label: "edit",
    action: "edit",
  },
  {
    label: "delete",
    action: "delete",
  },
  {
    label: "MarkSoldOut",
    action: "SoldOut",
  },
];
export const lookingForDropdownList = [
  {
    label: "edit",
    action: "edit",
  },
  {
    label: "delete",
    action: "delete",
  },
];
export const specializationDropdownList = [
  {
    value: 1,
    label: "Marketer",
  },
  {
    value: 2,
    label: "Broker",
  },
  {
    value: 3,
    label: "marketer_broker",
  },
  {
    value: 4,
    label: "Visitor",
  },
];
export const inquiryListColumns = [
  // {
  //   name: "index_id",
  //   label: "id",
  // },
  {
    name: "full_name",
    label: "Full_Name",
  },
  {
    name: "phone_number",
    label: "Phone_Number",
  },
  {
    name: "inquiry_type",
    label: "Type",
  },
  {
    name: "created_at",
    label: "Date_and_Time",
    render: (row, value) =>
      `${formatDate(value)}  ${getFormattedTime(value)}`,
  },
  // {
  //   name: "actions",
  //   label: "Actions", // keep this in English for clarity unless you localize buttons
  // },
];

export const FALHUB_GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.falhub.falhub";

export const FALHUB_APP_STORE_URL =
  "https://apps.apple.com/pk/app/falhub-%D9%81%D8%A7%D9%84-%D9%87%D8%A8/id6780416534";
